import { Label } from "@ifgengineering/client-invest-sdk";

const isProductionEnvironment = () => process.env.NODE_ENV === "production";

type TDealLabelKey =
  | "RETURNS"
  | "RISK"
  | "LIQUIDITY"
  | "TAX_BENEFITS"
  | "CAPITAL_APPRECIATION"
  | "DISTRIBUTION_PAID";
type TDealLabelValue = Pick<Label, "id" | "name">;
type TDealLabelMap = Record<TDealLabelKey, TDealLabelValue>;

export const DEAL_LABELS_MAP: TDealLabelMap = {
  RETURNS: {
    id: isProductionEnvironment() ? "4" : "31",
    name: "Annualised Target Return",
  },
  RISK: {
    id: isProductionEnvironment() ? "6" : "45",
    name: "Risk Profile",
  },
  LIQUIDITY: {
    id: isProductionEnvironment() ? "5" : "13",
    name: "Liquidity",
  },
  TAX_BENEFITS: {
    id: isProductionEnvironment() ? "7" : "43",
    name: "UK Tax Benefits",
  },
  CAPITAL_APPRECIATION: {
    id: isProductionEnvironment() ? "25" : "53",
    name: "Projected Capital Appreciation",
  },
  DISTRIBUTION_PAID: {
    id: isProductionEnvironment() ? "9" : "44",
    name: "Distribution Paid",
  },
};

// Filter labels for live deals to show only standard labels with backfill
export const filterLabelsForLiveDeals = (labels: Label[]): Label[] => {
  // Extract the 6 standard label IDs from DEAL_LABELS_MAP
  const allowedIds = Object.values(DEAL_LABELS_MAP).map((l) => l.id);

  // Get all uncolored labels sorted by priority
  const allUncoloredLabels = labels
    .filter(({ bgColor }) => !bgColor)
    .sort((a, b) => {
      if (a.priority === b.priority) return 0;
      if (!a.priority) return 1;
      if (!b.priority) return -1;
      return a.priority - b.priority;
    });

  // Split into: standard (by id) vs others
  const standardLabels = allUncoloredLabels.filter((label) =>
    allowedIds.includes(label.id)
  );

  const extraLabels = allUncoloredLabels.filter(
    (label) => !allowedIds.includes(label.id)
  );

  // How many of the 6 standard labels are missing
  const missingCount = allowedIds.length - standardLabels.length;

  // Backfill from extras by priority (only if we have missing standard labels)
  const backfillLabels = extraLabels.slice(0, missingCount);

  return [...standardLabels, ...backfillLabels];
};
